<template>
  <div>
    <div class="sign">
      <div class="sign-btn-wrapper">
        <a-button type="primary" class="sign-btn" @click="signClick">{{ signBtnTxt }}</a-button>
      </div>
      <div class="sign-img-wrapper" v-if="showSignImg && value">
        <img class="signImg" v-if="value" :src="value" alt="" />
      </div>
    </div>

    <a-modal v-model="visible" :maskClosable="false" :destroyOnClose="true" title="扫描二维码签名" @cancel="handleCancel">
      <template slot="footer">
        <template v-if="showHisBtn">
          <a-button type="normal" @click="handleHisSign" v-if="!useHisSign">历史签名</a-button>
          <a-button type="normal" @click="handleReSign" v-if="useHisSign">重新签名</a-button>
        </template>
        <a-button type="primary" @click="handleOk">{{ useHisSign ? '签名确认' : '我已完成' }}</a-button>
      </template>

      <div style="display: flex;align-items: center;" v-if="!useHisSign">
        <div style="width: 228px;height: 228px;position: relative;">
          <canvas ref="qrcode"></canvas>
          <div v-if="isTimeout" class="timeout-mask">
            <a-icon type="sync" class="sync-icon" @click="refreshCode" />
          </div>
        </div>
        <div style="margin-left: 16px;">
          <p :style="isTimeout ? 'font-weight: bold;font-size: 18px;' : ''">
            {{ isTimeout ? '二维码已失效' : '打开手机扫描二维码' }}
          </p>
          <p>{{ isTimeout ? '请重新点击按钮生成' : '按说明完成签名确认' }}</p>
        </div>
      </div>
      <div class="history-sign-preview" v-if="showHisImg && useHisSign">
        <img class="hisSignImg" :src="hisSignUrl" alt="" />
      </div>
    </a-modal>
  </div>
</template>

<script>
import QRCode from 'qrcode';
import { mapState } from 'vuex';
import { throttle } from '@/utils/util';

export default {
  props: {
    value: { type: String, default: '' },
    type: { type: String, default: '' },
    item: { type: Object, default: () => ({}) },
    docId: String,
    showHisBtn: { type: Boolean, default: false }, // 展示历史签名按钮
    showSignImg: { type: Boolean, default: true }, // 展示签名照片
    showHisImg: { type: Boolean, default: false }, // 展示历史签名照片
    signBtnTxt: { type: String, default: '签名提交' }, // 签名按钮文字
  },
  created() {
    this.$bus.$on('getSign', this.getSign);
  },
  computed: {
    ...mapState(['userInfo']),
    codeUrl() {
      const baseUrl = process.env.signUrl;
      return `${baseUrl}#/pages/sign/sign?name=${encodeURIComponent(this.userInfo.name)}&stuId=${this.userInfo.id}&field=${this.item.label}&docId=${
        this.docId
      }&eduCode=${this.userInfo.eduCode}&timestamp=${this.timestamp}`;
    },
    // 是否存在初始签名记录
    hasInitSign() {
      if (this.hisSignUrl) {
        return true;
      }
      if (this.value) {
        this.hisSignUrl = this.value;
        return true;
      }
      return false;
    },
  },
  data() {
    return {
      visible: false,
      timestamp: null,
      isTimeout: false,
      timer: null,
      useHisSign: false, // 是否使用历史签名
      hisSignUrl: null, // 历史签名照片url
    };
  },
  methods: {
    // 签名点击事件
    signClick() {
      if (this.type == 'collect') {
        this.$emit('open', 1);
      } else {
        this.openSign();
      }
    },

    // 打开签名弹窗
    openSign() {
      this.visible = true;
      this.setTime();
    },

    // 使用历史签名
    handleHisSign() {
      // 父页面传递了签名记录
      if (this.hasInitSign) {
        this.useHisSign = true;
        if (!this.showHisImg) {
          // 不展示历史签名照片，直接关闭签名弹窗
          this.handleOk();
        } else {
          this.timer && clearTimeout(this.timer);
        }
      } else {
        // 查询历史签名
        this.axios.get(`/biz/home/sign/his?docId=${this.docId}`).then(res => {
          if (res.result) {
            this.hisSignUrl = res.result;
            this.useHisSign = true;

            if (!this.showHisImg) {
              // 不展示历史签名照片，直接关闭签名弹窗
              this.handleOk();
            } else {
              this.timer && clearTimeout(this.timer);
            }
          }
        });
      }
    },

    // 重新签名
    handleReSign() {
      this.useHisSign = false;
      this.setTime();
    },

    // 刷新二维码
    refreshCode() {
      throttle(this.setTime(), 200);
    },

    // 设置倒计时
    async setTime() {
      const res = await this.axios.get('/common/qry/timeStamp');
      this.timestamp = +res.result;
      this.isTimeout = false;
      this.$nextTick(() => {
        QRCode.toCanvas(this.$refs.qrcode, this.codeUrl, error => {
          if (error) console.error(error);
          this.timer = setTimeout(() => {
            this.isTimeout = true;
            this.timer && clearTimeout(this.timer);
          }, 1000 * 60 * 5);
        });
      });
    },

    // 获取签名
    getSign(data) {
      if (this.type == 'collect') {
        if (data.docId == this.docId) {
          this.$emit('ok', data.fileUrl);
          this.visible = false;
        }
      } else {
        if (data.field === this.item.label) {
          this.$emit('change', data.fileUrl);
          this.$emit('ok', data.fileUrl);
          this.visible = false;
        }
      }
    },

    // 确定关闭弹窗
    handleOk() {
      if (this.useHisSign) {
        this.$emit('change', this.hisSignUrl);
        this.$emit('ok', this.hisSignUrl);
      }
      this.closeModal();
    },

    // 取消签名弹窗
    handleCancel() {
      this.closeModal();
    },

    // 关闭签名弹窗
    closeModal() {
      this.useHisSign = false;
      this.visible = false;
      this.timer && clearTimeout(this.timer);
    },
  },
};
</script>

<style lang="stylus" scoped>
@import '~styles/varibles.styl';

/* ========== 主布局（按钮区 + 图片预览区） ========== */
.sign {
  display: flex;
  align-items: flex-start;   /* flex-start: 顶部对齐; center: 居中对齐 */
  gap: 12px;                 /* 两组之间的间距 */
  flex-wrap: wrap;           /* 窄屏时换行 */
}

/* ========== 按钮区域 ========== */
.sign-btn-wrapper {
  display: flex;
  flex-direction: row;    /* row: 水平排列; column: 垂直排列 */
  align-items: center;    /* 居中对齐 */
  flex-shrink: 0;         /* 不缩小 */
  gap: 6px;               /* 按钮与文字间距*/
}

/* 签名按钮 */
.sign-btn {
  margin-top: 0px;
  background: $bgColor;
  color: #fff;
  border: none;
}

/* 历史签名按钮 */
.history-btn {
  color: $bgColor;
  cursor: pointer;
}

/* ========== 签名图片预览容器 ========== */
.sign-img-wrapper {
  width: 125px;              /* 旋转后占宽 = 原高125px */
  height: 80px;              /* 旋转后占高 = 原宽80px */
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;          /* 防止意外溢出 */
  flex-shrink: 0;
  border: 1px dashed #ddd;   /* 辅助观察边框，可移除 */
  border-radius: 4px;
  background: #fafafa;
}

/* 签名图片（旋转后） */
.signImg {
  width: 80px;
  height: 125px;
  transform: rotateZ(-90deg);
  transform-origin: center center;
}

/* ========== 二维码超时遮罩 ========== */
.timeout-mask {
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, .9);
  position: absolute;
  left: 0;
  top: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* 刷新图标 */
.sync-icon {
  font-size: 36px;
  cursor: pointer;
  color: #2caf7a;
  background-color: #fff;
  padding: 8px;
  border-radius: 50%;
  border: 2px solid #2caf7a;
}

/* ========== 历史签名预览（模态框内） ========== */
.history-sign-preview {
  display: flex;
  align-items: center;
  justify-content: center;   /* 水平居中 */
  width: 100%;
  min-height: 200px;         /* 保证有高度，避免图片过小时偏上 */
}

/* 历史签名图片（旋转后） */
.hisSignImg {
  width: 130px;
  height: 200px;
  transform: rotateZ(-90deg);
  transform-origin: center center;
  border: 1px dashed #ddd;
}
</style>



// WEBPACK FOOTER //
// src/common/components/QRcodeSign.vue